<template>
  <div v-loading="loading">
    <div class="title">挑战详情</div>
    <div class="page-container">
      <div
        class="fold-icon-wrapper"
        :class="{ fold: !collapse }"
        @click="handleCollapse"
      >
        <zhu-svg svg-class="fold-icon" svg-name="fold"></zhu-svg>
      </div>
      <div class="slider" :style="{ width: collapse ? '0px' : '200px' }">
        <el-tree
          node-key="tId"
          default-expand-all
          :data="treeDatas"
          :props="treeProps"
          :highlight-current="true"
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
          draggable
        >
          <span class="custom-tree-node" slot-scope="{ data }">
            <span class="tree-label">{{ data.name }}</span>
          </span>
        </el-tree>
        <zhu-button
          text="提交审核"
          type="primary"
          size="mini"
          :shadow="true"
          @click="handleSubmitAudit"
          v-if="
            !isDisabled &&
              authPermissions.includes(
                'challenge_service.api.fuwu_admin.my_challenges.submit_audit'
              )
          "
        ></zhu-button>
      </div>
      <div class="content" :style="{ width: collapse ? '940px' : '740px' }">
        <div v-if="pageMode === 'basic'" class="content-mode">
          <el-divider>挑战基本信息</el-divider>
          <el-button
            type="text"
            class="edit-btn"
            @click="switchEdit"
            v-if="
              !isDisabled &&
                authPermissions.includes(
                  'challenge_service.api.fuwu_admin.my_challenges.update'
                )
            "
            >{{ isEdit ? "保存" : "编辑" }}</el-button
          >
          <el-form
            :model="challengeInfo"
            ref="challengeForm"
            label-width="120px"
            size="mini"
            :rules="Rules"
          >
            <el-form-item label="挑战名称：" prop="name">
              <el-input
                v-model="challengeInfo.name"
                class="w-400"
                :disabled="!isEdit"
              ></el-input>
            </el-form-item>
            <el-form-item label="挑战难度：" prop="difficult_level">
              <el-select
                v-model="challengeInfo.difficult_level"
                placeholder="请选择难度"
                class="w-400"
                :disabled="!isEdit"
              >
                <el-option
                  v-for="(item, index) in difficult_level_list"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="应用场景：" required>
              <el-select
                multiple
                v-model="challengeInfo.use_cases"
                placeholder="请选择应用场景"
                class="w-400"
                :disabled="!isEdit"
              >
                <el-option label="实战营" :value="1"></el-option>
                <el-option label="赛训" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="岗位方向：" required>
              <CascaderPosition
                size="mini"
                multiple
                placeholder="请选择岗位方向"
                :jobId.sync="challengeInfo.job_id"
                :emitPath="false"
                @getNodes="handleGetJob"
                :disabled="!isEdit"
              ></CascaderPosition>
            </el-form-item>
            <el-form-item label="行业分类：">
              <el-cascader
                v-model="challengeInfo.common_industries"
                :options="industryList"
                :props="optionProps"
                class="w-400"
                placeholder="请选择行业分类"
                :disabled="!isEdit"
              ></el-cascader>
            </el-form-item>

            <el-form-item label="技能认证：" required>
              <ProjectStackSelect
                :disabled="!isEdit"
                :stacks="challengeInfo.stacks"
              ></ProjectStackSelect>
            </el-form-item>
            <!-- 挑战全流程优化移除以下字段 2022.06.20 -->
            <!-- <el-form-item label="挑战封面：" class="upload">
              <div class="upload-tips">
                建议尺寸：590*340，jpg/png，不超过5M
              </div>
              <UploadImage
                :api="api"
                space="_for_challenge_sub_project"
                folder="fuwu"
                uploadWidth="upload-w-270"
                :cover_url.sync="(challengeInfo.cover_file || {}).path"
                :cover_file_id.sync="(challengeInfo.cover_file || {}).id"
                :isDisabled="!isEdit"
              ></UploadImage>
            </el-form-item>
            <el-form-item label="成功勋章：" class="upload">
              <div class="upload-tips">
                建议尺寸：288*288，jpg/png，不超过5M
              </div>
              <UploadImage
                :api="api"
                space="_for_challenge_sub_project"
                folder="fuwu"
                uploadWidth="upload-w-270"
                :cover_url.sync="(challengeInfo.medal_file || {}).path"
                :cover_file_id.sync="(challengeInfo.medal_file || {}).id"
                :isDisabled="!isEdit"
              ></UploadImage>
            </el-form-item> -->
            <el-form-item label="挑战简介：" prop="description">
              <el-input
                type="textarea"
                class="w-400"
                v-model="challengeInfo.description"
                :disabled="!isEdit"
                :rows="3"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="pageMode === 'content'" class="content-mode">
          <el-button
            type="text"
            class="edit-btn"
            @click="switchContentEdit"
            v-if="
              !isDisabled &&
                authPermissions.includes(
                  'challenge_service.api.fuwu_admin.my_challenges.content.update'
                )
            "
            >{{ isEdit ? "保存" : "编辑" }}</el-button
          >
          <el-divider>挑战内容</el-divider>
          <div style="display:flex;align-items:center;" class="mb-12">
            <span style="font-size:14px;">附件：</span>
            <UploadFile
              :file.sync="content_attachment"
              :api="api"
              space="_for_challenge_sub_project"
              folder="fuwu"
              needCallback
              @cb="handleUploadCallback"
            ></UploadFile>
          </div>

          <MarkDown
            :value.sync="content"
            :disabled="isDisabled"
            :defaultOpen="isEdit ? 'edit' : 'preview'"
            space="_for_challenge_sub_project"
            video
          ></MarkDown>
          <div>
            <img
              src="@/assets/images/challenge-demo.png"
              alt=""
              style="width:100%"
            />
          </div>
        </div>
        <div v-if="pageMode === 'demand'" class="content-mode">
          <el-button
            type="text"
            class="edit-btn"
            @click="switchDemandEdit"
            v-if="
              !isDisabled &&
                authPermissions.includes(
                  'challenge_service.api.fuwu_admin.my_challenges.content.update'
                )
            "
            >{{ isEdit ? "保存" : "编辑" }}</el-button
          >
          <el-divider>批改要求</el-divider>
          <MarkDown
            :value.sync="demandContent"
            :disabled="isDisabled"
            :defaultOpen="isEdit ? 'edit' : 'preview'"
            space="_for_challenge_sub_project"
            video
          ></MarkDown>
        </div>
        <div v-if="pageMode === 'tips'" class="content-mode">
          <el-button
            type="text"
            class="edit-btn"
            @click="switchTipsEdit"
            v-if="
              !isDisabled &&
                authPermissions.includes(
                  'challenge_service.api.fuwu_admin.my_challenges.content.update'
                )
            "
            >{{ isEdit ? "保存" : "编辑" }}</el-button
          >
          <el-divider>解题提示</el-divider>
          <MarkDown
            :value.sync="tipsContent"
            :disabled="isDisabled"
            :defaultOpen="isEdit ? 'edit' : 'preview'"
            space="_for_challenge_sub_project"
            video
          ></MarkDown>
        </div>
        <div
          v-if="
            pageMode === 'answer' &&
              authPermissions.includes(
                'challenge_service.api.fuwu_admin.my_challenges.answers.index.all'
              )
          "
          class="content-mode"
        >
          <el-button
            type="text"
            class="edit-btn"
            @click="handleAddAnswer('add')"
            v-if="
              !isDisabled &&
                authPermissions.includes(
                  'challenge_service.api.fuwu_admin.my_challenges.answers.store'
                )
            "
            >添加答案</el-button
          >
          <el-divider>挑战标准答案</el-divider>
          <el-table :data="answerList" border size="mini">
            <el-table-column label="默认显示" prop="is_default" width="100">
              <template slot-scope="scope">
                {{ scope.row.is_default ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column
              label="版本号"
              prop="version"
              width="80"
            ></el-table-column>
            <el-table-column
              label="附件"
              prop="code_file"
              width="200"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <div class="ellipsis">
                  <el-link
                    :href="scope.row.code_file.path"
                    :underline="false"
                    >{{ scope.row.code_file.name }}</el-link
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="描述"
              prop="core_code"
              :show-overflow-tooltip="true"
              ><template slot-scope="scope">
                <div class="ellipsis">
                  {{ scope.row.core_code }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="更新日期"
              prop="created_at"
              width="120"
            ></el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-link
                  :underline="false"
                  @click="handleEditAnswer(scope.row.id, 'edit')"
                  v-if="
                    !isDisabled &&
                      authPermissions.includes(
                        'challenge_service.api.fuwu_admin.my_challenges.answers.update'
                      )
                  "
                  size="small"
                  >编辑</el-link
                >
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="pageMode === 'audit'">
          <el-divider>挑战审核记录</el-divider>
          <el-table :data="auditList" border size="mini">
            <el-table-column label="ID" prop="id" width="60"></el-table-column>
            <el-table-column
              label="生产价格"
              prop="teacher_production_price"
              width="100"
            ></el-table-column>
            <el-table-column label="审核理由" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <div class="ellipsis">
                  {{ scope.row.reason }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="审核日期" width="100">
              <template slot-scope="scope">
                {{ scope.row.created_at.substring(0, 10) }}
              </template>
            </el-table-column>
            <el-table-column
              label="审核结果"
              prop="status_label"
              width="80"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleCancel"
      v-loading="dialogLoading"
    >
      <div class="dialog-container">
        <el-form
          :model="editForm"
          ref="editForm"
          label-width="95px"
          size="mini"
        >
          <el-form-item label="版本号：" required>
            <el-input-number
              v-model="editForm.version"
              class="wd-270"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="附件：" required>
            <div class="upload-tips">说明：rar、zip格式，不超过500M</div>
            <UploadFile
              :file.sync="editForm.code_file"
              :api="api"
              space="_for_challenge_sub_project"
              folder="fuwu"
            ></UploadFile>
          </el-form-item>
          <el-form-item label="描述：" required>
            <MarkDown
              :value.sync="editForm.core_code"
              :defaultOpen="dialogVisible ? 'edit' : 'preview'"
            ></MarkDown>
          </el-form-item>
          <el-form-item label="是否默认：">
            <el-switch
              v-model="editForm.is_default"
              active-color="#13ce66"
              inactive-color="#efefef"
            >
            </el-switch>
          </el-form-item>
        </el-form>
        <el-button
          type="primary"
          size="medium"
          @click="handleSaveResult"
          class="submit-btn"
          v-if="
            authPermissions.includes(
              'challenge_service.api.fuwu_admin.my_challenges.answers.update'
            )
          "
          >{{ buttonType === "add" ? "提交" : "修改" }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import challengeService from "@/global/service/challenge";
import kcellService from "@/global/service/kcell";
import MarkDown from "@/components/Markdown.vue";
import ProjectStackSelect from "@/components/ProjectStackSelect";
import UploadFile from "@/components/UploadFile.vue";
import CascaderPosition from "./widgets/CascaderPosition.vue";
import API from "@/global/request/api";
import { mapState } from "vuex";
const difficult_level_list = [
  {
    label: "R1-简单",
    value: 1
  },
  {
    label: "R2-一般",
    value: 2
  },
  {
    label: "R3-中等",
    value: 3
  },
  {
    label: "R4-困难",
    value: 4
  },
  {
    label: "R5-非常困难",
    value: 5
  }
];
export default {
  components: {
    MarkDown,
    ProjectStackSelect,
    UploadFile,
    CascaderPosition
  },
  data() {
    return {
      treeProps: {
        label: "name",
        children: "children"
      },
      collapse: false,
      challengeInfo: {
        name: "",
        modeName: "默认模版",
        pages: [],
        description: null,
        difficult_level: null,
        use_cases: [],
        common_industries: [],
        stacks: [],
        job_id: []
      },
      editForm: {
        is_default: false,
        version: null,
        code_file: {},
        core_code: null
      },
      content: "",
      content_attachment: null,
      demandContent: "",
      tipsContent: "",
      loading: false,
      answerList: [],
      pageMode: "basic",
      auditList: [],
      difficult_level_list,
      api: API.challengeFile,
      Rules: {
        name: [{ required: true, message: "请输入挑战名称", trigger: "blur" }],
        difficult_level: [
          { required: true, message: "请选择难度", trigger: "change" }
        ],

        description: [
          { required: true, message: "请输入简介", trigger: "blur" }
        ]
      },
      isDisabled: false,
      isEdit: false,
      dialogVisible: false,
      buttonType: "add",
      dialogLoading: false,
      industryList: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false,
        checkStrictly: false,
        multiple: true
      }
    };
  },
  computed: {
    ...mapState(["authPermissions"]),
    treeDatas() {
      const name = this.challengeInfo.modeName;
      const children = [
        {
          id: 2,
          name: "挑战内容",
          pageMode: "content"
        },
        {
          id: 5,
          name: "批改要求",
          pageMode: "demand"
        },
        {
          id: 6,
          name: "解题提示",
          pageMode: "tips"
        },
        {
          id: 3,
          pageMode: "answer",
          name: "标准答案"
        },
        {
          id: 4,
          pageMode: "audit",
          name: "审核记录"
        }
      ];
      return [{ name, pageMode: "basic", children }];
    },
    treePaddingRight() {
      return this.collapse ? 0 : "30px";
    }
  },
  created() {
    this.getData();
    this.getConst();
  },
  methods: {
    getData() {
      this.loading = true;
      const id = this.$route.params.id;
      challengeService
        .myChallengeDetail(id)
        .then(res => {
          res.stacks = res.stacks.map(data => {
            data = {
              id: data.stack_id,
              level: data.stack_level,
              name: data.stack_name
            };
            return data;
          });
          const { status } = res;
          if (status === 3 || status === 4) {
            this.isDisabled = true;
          }
          this.challengeInfo = res;
          this.challengeInfo.modeName = res.name;
          this.challengeInfo.job_id = res.jobs.map(d => d.job_id);
          this.challengeInfo.common_industries = res.common_industries.map(
            d => d.id
          );
          this.auditList = res.audit_logs;
          this.content_attachment = res.attachment;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getConst() {
      kcellService.kcellIndustry().then(res => {
        this.industryList = res;
      });
    },
    getContent() {
      this.loading = true;
      const id = this.$route.params.id;
      challengeService
        .myChallengeContentDetail(id)
        .then(res => {
          if (res === null) {
            this.content = "";
          } else {
            this.content = res;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    switchEdit() {
      if (!this.isEdit) {
        this.isEdit = true;
        return;
      } else {
        this.$refs.challengeForm.validate(valid => {
          if (valid) {
            const params = {
              name: this.challengeInfo.name,
              description: this.challengeInfo.description,
              difficult_level: this.challengeInfo.difficult_level,
              use_cases: this.challengeInfo.use_cases,
              common_industries: this.challengeInfo.common_industries,
              jobs: this.challengeInfo.job_id.map(s => {
                return {
                  job_id: s
                };
              }),
              stacks: this.challengeInfo.stacks.map(data => {
                data = {
                  stack_id: data.id,
                  stack_level: data.level
                };
                return data;
              })
            };
            const id = this.$route.params.id;
            const hasStacks = params.stacks.length;
            if (!hasStacks) return this.$message.error("技能认证不能为空 ～");
            this.loading = true;
            challengeService
              .updateMyChallenge(id, params)
              .then(() => {
                this.$message.success("保存成功");
                this.getData();
              })
              .finally(() => {
                this.loading = false;
                this.isEdit = false;
              });
          }
        });
      }
    },
    switchContentEdit() {
      if (!this.isEdit) {
        this.isEdit = true;
        return;
      } else {
        this.$confirm("确认修改内容？").then(() => {
          if (this.content.length < 10) {
            return this.$message.error("内容过短，至少为10个字符～");
          }
          const params = {
            content: this.content
          };
          const id = this.$route.params.id;
          challengeService.myChallengeContentUpdate(id, params).then(() => {
            this.$message.success("保存成功");
            this.getContent();
            this.isEdit = false;
          });
        });
      }
    },
    switchDemandEdit() {
      if (!this.isEdit) {
        this.isEdit = true;
        return;
      } else {
        this.$confirm("确认修改批改要求？").then(() => {
          if (this.demandContent.length < 10) {
            return this.$message.error("批改要求过短，至少为10个字符～");
          }
          const params = {
            evaluate_require: this.demandContent
          };
          const id = this.$route.params.id;
          challengeService
            .myChallengeEvaluateRequireEdit(id, params)
            .then(() => {
              this.$message.success("保存成功");
              this.isEdit = false;
            });
        });
      }
    },
    switchTipsEdit() {
      if (!this.isEdit) {
        this.isEdit = true;
        return;
      } else {
        this.$confirm("确认解题提示？").then(() => {
          if (this.tipsContent.length < 10) {
            return this.$message.error("解题提示过短，至少为10个字符～");
          }
          const params = {
            answer_tip: this.tipsContent
          };
          const id = this.$route.params.id;
          challengeService.myChallengeAnswerTipEdit(id, params).then(() => {
            this.$message.success("保存成功");
            this.isEdit = false;
          });
        });
      }
    },
    getAnswer() {
      this.loading = true;
      const id = this.$route.params.id;
      challengeService
        .myChallengeAnswerAll(id)
        .then(res => {
          res.forEach(item => {
            item.created_at = item.created_at.substring(0, 10);
          });
          this.answerList = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCollapse() {
      this.collapse = !this.collapse;
    },
    handleNodeClick(data) {
      if (this.isEdit) {
        this.$message.error("请先保存当前信息");
        return;
      }
      if (data.pageMode === "basic") {
        this.pageMode = "basic";
        return;
      } else if (data.pageMode === "answer") {
        this.pageMode = "answer";
        this.getAnswer();
        return;
      } else if (data.pageMode === "audit") {
        this.pageMode = "audit";
        return;
      } else if (data.pageMode === "content") {
        this.pageMode = "content";
        this.getContent();
        return;
      } else if (data.pageMode === "demand") {
        this.pageMode = "demand";
        this.getDemand();
      } else if (data.pageMode === "tips") {
        this.pageMode = "tips";
        this.getTips();
      }
    },
    handleUploadCallback(e) {
      const id = this.$route.params.id;
      challengeService
        .challengeAttachment(id, { attachment_file_id: e })
        .then(() => {});
    },
    getDemand() {
      this.loading = true;
      const id = this.$route.params.id;
      challengeService
        .myChallengeEvaluateRequire(id)
        .then(res => {
          this.demandContent = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getTips() {
      this.loading = true;
      const id = this.$route.params.id;
      challengeService
        .myChallengeAnswerTip(id)
        .then(res => {
          this.tipsContent = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleAddAnswer(type) {
      this.buttonType = type;
      this.dialogVisible = true;
    },
    handleEditAnswer(id, type) {
      this.buttonType = type;
      this.dialogVisible = true;
      this.dialogLoading = true;
      let challengeId = this.$route.params.id;
      challengeService
        .myChallengeAnswerDetail(challengeId, id)
        .then(res => {
          this.editForm = res;
        })
        .finally(() => {
          this.dialogLoading = false;
        });
    },
    handleSaveResult() {
      const id = this.$route.params.id;
      const params = {
        version: this.editForm.version,
        code_file_id: this.editForm.code_file.id,
        core_code: this.editForm.core_code
      };
      for (let i in params) {
        if (!params[i]) {
          this.$message.error("缺少必要参数~");
          return;
        }
      }
      params.is_default = this.editForm.is_default;
      if (this.buttonType === "add") {
        challengeService.createMyChallengeAnswer(id, params).then(() => {
          this.editForm.version = null;
          this.editForm.core_code = "";
          this.editForm.code_file = {};
          this.editForm.is_default = false;
          this.getAnswer();
          this.dialogVisible = false;
          this.$message.success("提交成功");
        });
      } else if (this.buttonType === "edit") {
        const answerId = this.editForm.id;
        challengeService
          .myChallengeAnswerUpdate(id, answerId, params)
          .then(() => {
            this.editForm.version = null;
            this.editForm.core_code = "";
            this.editForm.code_file = {};
            this.editForm.is_default = false;
            this.getAnswer();
            this.dialogVisible = false;
            this.$message.success("保存成功");
          });
      }
    },
    handleCancel() {
      this.$confirm("关闭将清除所有已填写数据,是否关闭？").then(() => {
        this.editForm.version = null;
        this.editForm.core_code = "";
        this.editForm.code_file = {};
        this.editForm.is_default = false;
        this.dialogVisible = false;
      });
    },
    handleSubmitAudit() {
      this.$confirm("确认提交审核？").then(() => {
        const id = this.$route.params.id;
        this.loading = true;
        challengeService
          .myChallengeAudit(id)
          .then(() => {
            this.$message.success("提交成功，请耐心等待审核结果～");
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    handleGetJob(e) {
      this.challengeInfo.job_id = e.map(s => s.value);
    }
  }
};
</script>
<style lang="less" scoped>
.slider {
  padding-top: 12px;
  min-height: 500px;
  transition: all 0.2s ease-out;
  overflow: hidden;
  .el-button {
    width: 120px;
    display: block;
    margin: 15px 20px;
  }
}
.content {
  flex: 1;
}
.el-card {
  margin-bottom: 20px;
}
.el-row {
  margin-bottom: 20px;
}
.form-title {
  font-size: 14px;
  padding-left: 20px;
  margin-bottom: 20px;
}
.form-label {
  font-size: 14px;
  width: 90px;
  text-align: right;
}
.el-col {
  display: flex;
}
.form-desc {
  margin-left: 10px;
  font-size: 14px;
  img {
    width: 160px;
    height: 100px;
    object-fit: cover;
  }
}
.dialog-container {
  padding: 20px 50px;
  .submit-btn {
    margin-left: 95px;
  }
}
.page-container {
  position: relative;
  display: flex;
}
.fold-icon-wrapper {
  position: absolute;
  top: 6px;
  left: -18px;
  width: 20px;
  height: 32px;
  line-height: 30px;
  text-align: center;
  border: 1px solid #dee0e3;
  border-radius: 4px;
  background-color: #fff;
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  transition: all 0.2s ease-out;
  cursor: pointer;
  &.fold {
    left: -30px;
    transform: rotate(180deg);
  }
  .fold-icon {
    color: #656a72;
    &:hover {
      color: #409eff;
    }
  }
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 8px;
  font-size: 14px;
  .tree-label {
    width: 156px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .tree-operation {
    height: 0;
    overflow: hidden;
  }
  &:hover .tree-operation {
    height: 14px;
  }
}
.el-col-audit {
  display: block;
}
.upload-tips {
  line-height: 28px;
  margin-bottom: 10px;
}
.upload {
  margin-right: 70px;
  /deep/.el-form-item__content {
    line-height: 60px;
  }
  /deep/.upload-icon {
    width: 270px;
    height: 130px;
    line-height: 120px;
    font-size: 20px;
  }
}
.content-mode {
  position: relative;
}
.edit-btn {
  position: absolute;
  top: -35px;
  right: 0;
}
</style>
